import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { GetOrderResponseData } from "../types/order"

const getData = async (uuid: string | undefined) => {
  const { data } = await api.get(`/orders/${uuid}`)
  return data
}

export const useOrderDetail = (uuid: string | undefined):
  QueryObserverBaseResult<GetOrderResponseData> => {
  const { data, ...props } = useQuery<GetOrderResponseData>(
    queryKeys.ORDER(uuid),
    () => getData(uuid),
    { enabled: Boolean(uuid) }
  )
  return { data, ...props }
}
